// extracted by mini-css-extract-plugin
export var container = "_i7-0";
export var content = "_i7-3";
export var customerTitle = "_i7-4";
export var empty = "_i7-5";
export var gray = "_i7-6";
export var header = "_i7-7";
export var info = "_i7-8";
export var loading = "_i7-2";
export var loadingCard = "_i7-9";
export var oneLine = "_i7-a";
export var personName = "_i7-e";
export var pillContainer = "_i7-b";
export var selected = "_i7-1";
export var text = "_i7-c";
export var twoLines = "_i7-d";
export var unread = "_i7-f";
export var unreadIndicator = "_i7-g";